import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { linkWithUnderlineHover } from 'styles/mixins';

interface LinkProps {
  border?: number | undefined;
  linkColor?: string | undefined;
}

const ArrowLinkWrapper = styled(Link)<LinkProps>`
  display: flex;
  align-items: center;

  span {
    ${(props) => linkWithUnderlineHover('&', props.border, props.linkColor)};
  }

  svg {
    margin-left: 1rem;
  }
`;

export {
  ArrowLinkWrapper
};
